import { getSelectedTableView, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import type { ActionSource } from 'owa-analytics-types';
import { lazyMarkRowsPinnedUnpinned } from 'owa-mail-triage-action';
import { resetFocus } from 'owa-mail-focus-manager';
import getEffectiveRowKeys from 'owa-mail-list-store/lib/utils/getEffectiveRowKeys';

/**
 * Set item(s) to Pinned or Unpinned state based on current selected item(s)' pinned state.
 * This function supports multi-select in mail list.
 *
 * @param isPinnedToSet can be used to set item's pinned state, and can be undefined.
 * If undefined, this function will calculate the current pinned state given current selected items' pinned state.
 * This is to allow for "toggle" functionality, of wanting to toggle pinned state without parent caller needing
 * to know current item's pinned state.
 * @param rowKeysToUse optional array of row keys to use instead of selected row keys
 */
export default function onPinUnpin(
    actionSource: ActionSource,
    isPinnedToSet?: boolean,
    rowKeysToUse?: string[]
): void {
    const shouldGetEffectiveTableView = !rowKeysToUse;
    const tableView = getSelectedTableView(shouldGetEffectiveTableView);
    if (!tableView) {
        return;
    }
    const rowKeys =
        rowKeysToUse ??
        (tableView.isInVirtualSelectAllMode ? tableView.rowKeys : getEffectiveRowKeys(tableView));

    if (isPinnedToSet === undefined) {
        // The logic to decide whether to pin or unpin the mail item(s):
        // 1) If any of the item(s) are pinned, unpin all the items.
        // 2) Otherwise, pin all the items.
        isPinnedToSet = true;
        for (const rowKey of rowKeys) {
            if (MailRowDataPropertyGetter.getIsPinned(rowKey, tableView)) {
                isPinnedToSet = false;
                break;
            }
        }
    }

    lazyMarkRowsPinnedUnpinned.importAndExecute(rowKeys, tableView.id, isPinnedToSet, actionSource);

    resetFocus('pinUnpinCommand');
}
